import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { CONTACT, GA6_PHOTOS } from "@/data/site";
import { Reveal } from "./Reveal";
import { EASE } from "./motion";

export const Ga6Teaser = () => (
  <Reveal className="mt-24">
    <div className="border border-stone-700 p-8 lg:p-12 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center" data-testid="ga6-teaser">
      <div className="lg:col-span-5">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#C29B38]">Coming soon · A new product by Carvings</p>
        <p className="mt-4 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight">GA6 <span className="text-stone-400">—</span> Premium Microcement</p>
        <p className="mt-5 text-stone-400 font-light leading-relaxed max-w-md">Seamless, joint-free surfaces for floors, walls and wet areas — the finish behind many of our interiors, soon available pan-India.</p>
        <a href={CONTACT.ga6} target="_blank" rel="noopener noreferrer" data-testid="ga6-promo-link"
          className="group mt-8 inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-[#FBFBF9]">
          <span className="link-line">www.ga6.in</span>
          <span className="w-10 h-10 rounded-full border border-stone-500 flex items-center justify-center transition-all duration-300 group-hover:rotate-45 group-hover:border-[#C29B38] group-hover:text-[#C29B38]"><ArrowUpRight size={16} /></span>
        </a>
      </div>
      <motion.div className="lg:col-span-7 grid grid-cols-3 gap-3 lg:gap-4" data-testid="ga6-photos" initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.3 }} transition={{ staggerChildren: 0.15 }}>
        {GA6_PHOTOS.map((p, i) => (
          <motion.a key={p.src} href={CONTACT.ga6} target="_blank" rel="noopener noreferrer" data-testid={`ga6-photo-${i}`}
            variants={{ hidden: { clipPath: "inset(100% 0 0 0)" }, show: { clipPath: "inset(0% 0 0 0)" } }} transition={{ duration: 1, ease: EASE }} whileTap={{ scale: 0.97 }}
            className={`group relative overflow-hidden bg-stone-800 aspect-[3/4] ${i === 1 ? "lg:-translate-y-6" : ""} ${i === 2 ? "lg:translate-y-6" : ""}`}>
            <img src={p.src} alt={p.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
            <span className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-[0.2em] text-white/90 bg-black/30 backdrop-blur px-2 py-1">{p.label}</span>
          </motion.a>
        ))}
      </motion.div>
    </div>
  </Reveal>
);
